const state = {
  timesheetIdsAreLoaded: false,
  awaitingSubmissionTimesheet: JSON.parse(localStorage.getItem("awaitingSubmissionTimesheet")),
  submittedTimesheets: JSON.parse(localStorage.getItem("submittedTimesheets")),
  awaitingApprovalTimesheets: JSON.parse(localStorage.getItem("awaitingApprovalTimesheets")),
  approvedTimesheets: JSON.parse(localStorage.getItem("approvedTimesheets"))
}

const getters = {
  getTimesheetIdsAreLoaded(state) {
    return state.timesheetIdsAreLoaded;
  },
  getAwaitingSubmissionTimesheet(state) {
    return state.awaitingSubmissionTimesheet;
  },
  getSubmittedTimesheets(state) {
    return state.submittedTimesheets;
  },
  getAwaitingApprovalTimesheets(state) {
    return state.awaitingApprovalTimesheets;
  },
  getApprovedTimesheets(state) {
    return state.approvedTimesheets;
  }
}

const actions = {
  changeTimesheetIdsAreLoaded({commit}, timesheetIdsAreLoaded) {
    commit("setTimesheetIdsAreLoaded", timesheetIdsAreLoaded);
  },
  changeAwaitingSubmissionTimesheet({commit}, awaitingSubmissionTimesheet) {
    commit("setAwaitingSubmissionTimesheet", awaitingSubmissionTimesheet);
  },
  changeSubmittedTimesheets({commit}, submittedTimesheets) {
    commit("setSubmittedTimesheets", submittedTimesheets);
  },
  changeAwaitingApprovalTimesheets({commit}, awaitingApprovalTimesheets) {
    commit("setAwaitingApprovalTimesheets", awaitingApprovalTimesheets);
  },
  changeApprovedTimesheets({commit}, approvedTimesheets) {
    commit("setApprovedTimesheets", approvedTimesheets);
  }
}

const mutations = {
  setTimesheetIdsAreLoaded(state, timesheetIdsAreLoaded) {
    state.timesheetIdsAreLoaded = timesheetIdsAreLoaded;
  },
  setAwaitingSubmissionTimesheet(state, awaitingSubmissionTimesheet) {
    state.awaitingSubmissionTimesheet = awaitingSubmissionTimesheet;
    localStorage.setItem("awaitingSubmissionTimesheet", JSON.stringify(awaitingSubmissionTimesheet));
  },
  setSubmittedTimesheets(state, submittedTimesheets) {
    state.submittedTimesheets = submittedTimesheets;
    localStorage.setItem("submittedTimesheets", JSON.stringify(submittedTimesheets));
  },
  setAwaitingApprovalTimesheets(state, awaitingApprovalTimesheets) {
    state.awaitingApprovalTimesheets = awaitingApprovalTimesheets;
    localStorage.setItem("awaitingApprovalTimesheets", JSON.stringify(awaitingApprovalTimesheets));
  },
  setApprovedTimesheets(state, approvedTimesheets) {
    state.approvedTimesheets = approvedTimesheets;
    localStorage.setItem("approvedTimesheets", JSON.stringify(approvedTimesheets));
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
